import { Trans } from '@lingui/react/macro';
import { format, isValid } from 'date-fns';

import type { PerioToothData } from '@/modules/claims/freeClaims/insuranceExport/types';

import { getToothStatusAbbreviation } from './helpers';
import { MeasurementSection } from './MeasurementSection';
import { ToothNumbers } from './ToothNumbers';

export const TeethSection = ({
  teeth,
  isUpper,
  examDate,
}: {
  teeth: PerioToothData[];
  isUpper: boolean;
  examDate?: string;
}) => {
  return (
    <div className={isUpper ? 'vai-border-b-2 vai-border-black' : ''}>
      <ToothNumbers teeth={teeth} isUpper={isUpper} />

      {/* Exam Date and Tooth Type Labels */}
      <div className="vai-flex vai-text-xs vai-border-b vai-border-gray-400">
        <div className="vai-w-40 vai-p-1 vai-font-semibold vai-bg-gray-50 vai-border-r vai-border-gray-400">
          {examDate && isValid(new Date(examDate)) && (
            <Trans>EXAM DATE: {format(new Date(examDate), 'MM/dd/yyyy')}</Trans>
          )}
        </div>
        <div className="vai-flex vai-flex-1">
          {teeth.map((tooth, index) => (
            <div
              key={tooth.toothNumber}
              className={`vai-flex-1 vai-p-1 vai-text-center ${
                index < teeth.length - 1
                  ? 'vai-border-r vai-border-gray-400'
                  : ''
              }`}
            >
              {tooth.surfaceType}
            </div>
          ))}
        </div>
      </div>

      <MeasurementSection teeth={teeth} side="facial" />
      <MeasurementSection teeth={teeth} side="lingual" />

      {/* Side Labels */}
      <div className="vai-flex vai-border-b vai-border-gray-400">
        <div className="vai-w-40 vai-p-1 vai-border-r vai-border-gray-400 vai-text-center vai-font-semibold">
          {isUpper ? 'L' : 'F'}
        </div>
        <div className="vai-flex vai-flex-1">
          {teeth.map((tooth, index) => (
            <div
              key={tooth.toothNumber}
              className={`vai-flex-1 vai-p-1 vai-text-center vai-text-red-500 ${
                index < teeth.length - 1
                  ? 'vai-border-r vai-border-gray-400'
                  : ''
              }`}
            >
              {getToothStatusAbbreviation(tooth.toothState)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
